import * as Yup from "yup";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { HouseContentsSum } from "../houseContentsConstants";
import { HouseContentsProductDetailsFormValues } from "../houseContentsFormValuesInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<HouseContentsProductDetailsFormValues> => {
    const { getText } = TextManager;
    const invalidSumText = getText(
      "housecontentsform.validation.calculatorcoverageamount_validsum",
    );

    return Yup.object({
      fullRental: Yup.boolean().required(),
      coverageAmount: Yup.number()
        .required(
          getText(
            "housecontentsform.validation.calculatorcoverageamount_required",
          ),
        )
        .min(HouseContentsSum.LOWER_LIMIT, invalidSumText)
        .max(
          HouseContentsSum.UPPER_LIMIT,
          ErrorPrefix.BREAKING + invalidSumText,
        )
        .when("fullRental", {
          is: true,
          then: (schema) =>
            schema
              .max(
                HouseContentsSum.UPPER_LIMIT_HOUSE_RENTED_OUT,
                ErrorPrefix.BREAKING +
                  getText(
                    "housecontentsform.validation.calculatortoohighrental",
                  ),
              )
              .min(
                HouseContentsSum.LOWER_LIMIT,
                getText("housecontentsform.validation.calculatortoolowrental"),
              ),
        }),
      fireResistantBuildingMaterial: Yup.mixed<BooleanFormType>().required(
        getText("housecontentsform.validation.fireresistantbuildingmaterial"),
      ),
      people: Yup.mixed().when("coverageAmount", {
        is: "",
        then: (schema) => schema.required(),
      }),
      rooms: Yup.mixed().when("coverageAmount", {
        is: "",
        then: (schema) => schema.required(),
      }),
      standard: Yup.mixed().when("coverageAmount", {
        is: "",
        then: (schema) => schema.required(),
      }),
    })
      .concat(getInjuriesSchema())
      .defined();
  };
